module.exports = __webpack_public_path__ + "img/vertical_7_1_0.545394fe.png";